<template>
  <ul class="user-widget navigation-level navigation-level--1">
    <li v-if="currentUser" class="navigation__item navigation__item--stacked">
      <nuxt-link
        exact
        to="/my-account"
        tag="a"
        class="navigation__link"
        title="Visit my account"
        >{{ currentUser.name }}'s Account</nuxt-link
      >
      <ul
        class="navigation-level navigation-level--2 navigation-level--stacked"
      >
        <li class="navigation__item">
          <nuxt-link
            exact
            to="/my-account"
            tag="a"
            class="navigation__link"
            title="Edit profile"
            >My Subscription</nuxt-link
          >
        </li>
        <li class="navigation__item">
          <nuxt-link
            exact
            :to="{ name: 'my-account-profile' }"
            tag="a"
            class="navigation__link"
            title="Edit profile"
            >{{ "Profile" }}</nuxt-link
          >
        </li>
      </ul>
    </li>
    <li v-if="currentUser" class="navigation__item">
      <a class="navigation__link" title="Log out" @click.prevent="logout">{{
        "Logout"
      }}</a>
    </li>
    <li v-else class="navigation__item">
      <nuxt-link
        exact
        to="/login"
        tag="a"
        class="navigation__link"
        title="Log in"
        >{{ "Login" }}</nuxt-link
      >
    </li>
  </ul>
</template>

<script setup lang="ts">
  const userStore = useUserStore();
  const currentUser = computed(() => userStore.user);

  const logout = () => {
    userStore.logout();
    navigateTo("/login");
  };
</script>

<style lang="scss" scoped>
  .navigation-level--1 {
    > .navigation__item {
      > .navigation__link {
        background: $pfgrey;
        color: $pfgreen;
      }

      &:hover {
        > .navigation__link {
          background-color: $pforange;
          color: $white;
          text-decoration: none;
        }
      }
    }
  }

  .user-widget {
    @include respond-to-max("lg") {
      margin-right: 20px;
      background: $pfgreen;

      li {
        a {
          color: $white;
        }
      }
    }

    @include respond-to-max("sm") {
      display: flex;
      flex-direction: column;
      width: 70%;

      .navigation__item {
        .navigation__link {
          padding: 10px;
          font-size: 0.8rem;

          .user-icon {
            display: none;
          }
        }
      }
    }
  }
</style>
